import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
// import mapState from './store/mapState'
// import { mapState } from 'vuex'

import './registerServiceWorker'

Vue.config.productionTip = false

Vue.component('testbox', require('./components/TestBox.vue').default);
Vue.component('d-d', require('./helper/DD.vue').default);


new Vue({
  vuetify,
  router,
  store,
  // computed :{
  //   ...mapState(['testmp']),
  // }, 
  render: h => h(App)
}).$mount('#app')
